import React from "react";

import { Scaffold, Footer } from "components/Shared";
import { Banner, Hightlights } from "components/CallCenter";

export const CallCenter: React.FC = () => {
  return (
    <Scaffold>
      <Banner />
      <Hightlights />
      <Footer />
    </Scaffold>
  );
};
